import { lazy } from "react";

export const RewardPage = lazy(() => import("./rewardPage"));
